var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinGeneroIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 44.907,
    viewBox: "0 0 30 44.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8115",
    "data-name": "Rectangle 8115",
    width: 30,
    height: 44.907,
    transform: "translate(-2 -3)",
    fill: "#1c5866",
    stroke: "#1b5866",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10901",
    "data-name": "Group 10901",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9021",
    "data-name": "Group 9021",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-help-circle",
    "data-name": "Icon feather-help-circle",
    transform: "translate(-1.138 5.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24047",
    "data-name": "Path 24047",
    d: "M25.275,14.138A11.138,11.138,0,1,1,14.138,3,11.138,11.138,0,0,1,25.275,14.138Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1b5866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24048",
    "data-name": "Path 24048",
    d: "M13.635,12.726a3.341,3.341,0,0,1,6.493,1.114c0,2.228-3.341,3.341-3.341,3.341",
    transform: "translate(-2.738 -1.929)",
    fill: "none",
    stroke: "#1b5866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24049",
    "data-name": "Path 24049",
    d: "M18,25.5h0",
    transform: "translate(-3.862 -5.793)",
    fill: "none",
    stroke: "#1b5866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinGeneroIcon);
export default __webpack_public_path__ + "static/media/sin_genero_icon.2137c602c9d230f02ea633274b4393b6.svg";
export { ForwardRef as ReactComponent };